import React, { useEffect, useState } from 'react'
import { useTranslate, useRecordContext } from 'react-admin'
import { ShowElement } from 'src/components/uiElements/CRUD/ShowElement'
import { useReservationInfo } from '../../context/ReservationContext'
import { VOUCHER_PERMISSION_ENTITY } from 'src/helper/resourcesByPermission'
import { PERMISSION_SHOW } from 'src/helper/Permission'
import { HasPermission, hasPermissionFunction } from 'src/helper/HasPermission'
import { itemServices } from 'src/services/reservation/item/item.service'
import { Box, CircularProgress, Typography } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh';
import Tooltip from '@mui/material/Tooltip';

export const BillingStatusField = () => {
  const record = useRecordContext()
  const { reservationInfo, setReservationInfo} = useReservationInfo()
  const [billingStatus, setbillingStatus] = useState('')
  const translate = useTranslate()
  const [isLoading, setIsLoading] = useState(false)

  useEffect(()=>{
    getBillingStatus(record?.hash_)
  },[record])

  const getBillingStatus = async (hash, from_cache = true) => {
    try {
      if (hash) {
        let status = reservationInfo?.billing_info?.[hash]?.billable_status
        if(!status || !from_cache){
          setIsLoading(true)
          const billing = await itemServices.get_billing_status(hash,from_cache)
          setIsLoading(false)
          setReservationInfo((prevInfo) => {
            let newBillingInfo = { ...prevInfo?.billing_info }
            newBillingInfo[record?.hash_] = billing
            return {
              ...prevInfo,
              billing_info: newBillingInfo,
            }
          })
          setbillingStatus(billing.billable_status)
        } else {
          setbillingStatus(status)
        }
      }
    } catch (error) {
      return 'ERROR'
    }
  }
  return (
    <HasPermission permission={PERMISSION_SHOW} resource={VOUCHER_PERMISSION_ENTITY}>
      {
      isLoading ? 
        <Box style={{ padding: '5px 0px 5px 0px' }} display={'flex'} alignItems={'center'}>
          <Typography
            variant='h7'
            component='span'
            style={{
              padding: '0px 5px 0px 5px',
              fontWeight: 600,
              flex: 1,
              maxWidth: 'fit-content'
            }}
          >
            {`${translate('ra.field.billing_status')}:`}
          </Typography>
          <CircularProgress size={20} /> 
        </Box>
        :
        <div style={{display:'flex', flexDirection:'row', alignItems:'center'}}>
          <ShowElement data={billingStatus} label={translate('ra.field.billing_status')} status />
          {hasPermissionFunction('itemBilling', 'show') && 
          <Tooltip title={translate('ra.action.update')}>
            <RefreshIcon onClick={async ()=>await getBillingStatus(record?.hash_, false)}   color='info' style={{marginLeft:'15px', cursor:'pointer'}}/>
          </Tooltip>}
        </div>
      }
    </HasPermission>
  )
}
